import { Routes } from '@angular/router';
import { HomePageComponent } from './pages/home/home-page.component';
import { AboutPageComponent } from './pages/about/about-page.component';
import { ServicesPageComponent } from './pages/services/services-page.component';
import { BlogPageComponent } from './pages/blog/blog-page.component';
import { CareersPageComponent } from './pages/careers/careers-page.component';
import { ContactPageComponent } from './pages/contact/contact-page.component';

export const routes: Routes = [
  { path: '', component: HomePageComponent, title: 'Data BI Solutions' },
  { path: 'services', component: ServicesPageComponent, title: 'Services — Data BI Solutions' },
  { path: 'about', component: AboutPageComponent, title: 'À propos — Data BI Solutions' },
  { path: 'blog', component: BlogPageComponent, title: 'Blog — Data BI Solutions' },
  { path: 'careers', component: CareersPageComponent, title: 'Carrières — Data BI Solutions' },
  { path: 'contact', component: ContactPageComponent, title: 'Contact — Data BI Solutions' },
  { path: '**', redirectTo: '' },
];
